import { Box } from '@factorialco/deprecated-design-system'
import { F0Checkbox } from '@factorialco/f0-react'

import { useTreeContext } from 'modules/job_catalog/components/JobCatalogTree/context'

interface Props {
  nodeId: string
  checked: boolean
  disabled: boolean
}

const Checkbox = ({ nodeId, checked, disabled }: Props) => {
  const { onMultiSelectNode } = useTreeContext()

  // Prevent the click event from bubbling up to the parent node
  // This is to prevent the node from being selected when the checkbox is clicked
  const handleClick = (event: MouseEvent) => {
    event.stopPropagation()
  }

  return (
    <Box onClick={handleClick}>
      <F0Checkbox
        onCheckedChange={(newChecked) => onMultiSelectNode(nodeId, newChecked)}
        checked={checked}
        disabled={disabled}
      />
    </Box>
  )
}

export default Checkbox
